import Vue from 'vue';
import moment from 'moment';

function checkIfValidDate(dte) {
  if (dte && moment(dte).year() > 1900)
    return true;
  else
    return false;
}

Vue.filter('formatDateDDMMYYY', function (value) {
  if (checkIfValidDate(value)) {
    return moment(value).format('DD/MM/YYYY')
  }
  else
    return '';
});

Vue.filter('formatDateDDMMYYYYHHmm', function (value) {
  if (value) {
    return moment(value).format('DD/MM/YYYY HH:mm')
  }
});

Vue.filter('formatDateDDMMYYHHmm', function (value) {
  if (value) {
    return moment(value).format('DD/MM/YY HH:mm')
  }
});

Vue.filter('formatDateDDMMYYYYHHMMSS', function (value) {
  if (value) {
    return moment(value).format('LLL')
  }
});

Vue.filter('formatDateHHMMSS', function (value) {
  if (value) {
    return moment(value).format('HH:mm:ss')
  }
});

Vue.filter('formatDateHHmm', function (value) {
  if (value) {
    return moment(value).format('HH:mm')
  }
});

Vue.filter('formatDateLLLL', function (value) { //format:Tuesday, November 1, 2022 12:00 AM
  if (value) {
    return moment(value).format('LLLL');
  }
});

Vue.filter('trimFloatDecimals', function (value) {
  if (value) {
    return Number.parseFloat(value).toFixed(0);
  }
});

Vue.filter('twoDecimals', function (value, floatConv = false) {
  if (value) {
    let temp = parseFloat(value).toFixed(2);
    return floatConv ? parseFloat(temp) : temp;
  }

  return floatConv ? '0' : 0;
});

Vue.filter('formatDateHHmmEmpSchedB', function (value) {
  if (value) {
    if (value.periodTypeId == 1)
      return moment(value.periodBegin).format('HH:mm');
    else
      return '-';
  }
});

Vue.filter('formatDateHHmmEmpSchedE', function (value) {
  if (value) {
    //console.log(value);
    if (value.periodTypeId == 1)
      return moment(value.periodEnd).format('HH:mm');
    else
      return '-';
  }
});

Vue.filter('formatDateHHmmEmpSchedD', function (value) {
  if (value) {
    if (value.periodTypeId == 1)
      return value.periodDuration;
    else
      return '1440';
  }
});

Vue.filter('displayXchars', function (value, length) {
  if (!value)
    return '';

  if (value.length <= length)
    return value;

  return `${value.substring(0, length - 3)}...`
});

Vue.filter('stringifyNumber', function (value, length) {
  if (!value)
    return '';

  const special = ['zeroth', 'first', 'secodayd', 'third', 'fourth', 'fifth', 'sixth', 'seventh', 'eighth', 'ninth', 'tenth', 'eleventh', 'twelvth', 'thirteenth', 'fourteenth', 'fifteenth', 'sixteenth', 'seventeenth', 'eighteenth', 'nineteenth'];
  const deca = ['twent', 'thirt', 'fourt', 'fift', 'sixt', 'sevent', 'eight', 'ninet'];

  if (value < 20)
    return special[value];

  if (value % 10 === 0)
    return deca[Math.floor(value / 10) - 2] + 'ieth';

  return deca[Math.floor(value / 10) - 2] + 'y-' + special[value % 10];
});

Vue.filter('distanceForMap', function (value) { //value is in metetrs
  if (value <= 100)
    return `All`

  if (value < 1000)
    return `${value} m`

  if (value >= 1000)
    return `${value / 1000} km`
});

Vue.filter('numberToWord', function (value, length) {
  if (!value)
    return '';

  const numbersToWords = {
    0: "zero",
    1: "one",
    2: "two",
    3: "three",
    4: "four",
    5: "five",
    6: "six",
    7: "seven",
    8: "eight",
    9: "nine",
    10: "ten",
    11: "eleven",
    12: "twelve",
    13: "thirteen",
    14: "fourteen",
    15: "fifteen",
    16: "sixteen",
    17: "seventeen",
    18: "eighteen",
    19: "nineteen",
    20: "twenty",
    30: "thirty",
    40: "forty",
    50: "fifty",
    60: "sixty",
    70: "seventy",
    80: "eighty",
    90: "ninety",
  };

  // Define the convertNumberToWords function
  function convertNumberToWords(number) {
    // if number present in object no need to go further
    if (number in numbersToWords) return numbersToWords[number];

    // Initialize the words variable to an empty string
    let words = "";

    // If the number is greater than or equal to 100, handle the hundreds place (ie, get the number of hundres)
    if (number >= 100) {
      // Add the word form of the number of hundreds to the words string
      words += convertNumberToWords(Math.floor(number / 100)) + " hundred";

      // Remove the hundreds place from the number
      number %= 100;
    }

    // If the number is greater than zero, handle the remaining digits
    if (number > 0) {
      // If the words string is not empty, add "and"
      if (words !== "") words += " and ";

      // If the number is less than 20, look up the word form in the numbersToWords object
      if (number < 20) words += numbersToWords[number];
      else {
        // Otherwise, add the word form of the tens place to the words string
        //if number = 37, Math.floor(number /10) will give you 3 and 3 * 10 will give you 30
        words += numbersToWords[Math.floor(number / 10) * 10];

        // If the ones place is not zero, add the word form of the ones place
        if (number % 10 > 0) {
          words += "-" + numbersToWords[number % 10];
        }
      }
    }

    // Return the word form of the number
    return words;
  }

  return convertNumberToWords(value);
});
